import { Bert } from 'meteor/themeteorchef:bert';
import { isNil } from 'lodash';

import httpPromise from '../http-call-promise-wrapper';

/**
 * Gets the coordinates of the location given and centers the map in that location.
 *
 * @async
 * @param {object} arg - The object argument.
 * @param {string} arg.searchLoc - The name of the location to search.
 * @param {object} arg.leafletMap - The leaflet map to update.
 * @returns {string} The location's full name or an empty string if something goes wrong.
 */
// eslint-disable-next-line consistent-return
const searchLocation = async ({ searchLoc, leafletMap }) => {
  const urlforPlace = location =>
    `https://nominatim.openstreetmap.org/search?format=json&limit=5&q=${location}`;
  try {
    const response = await httpPromise('GET', urlforPlace(searchLoc.trim()));
    const firstResult = response.data[0];
    if (isNil(firstResult)) throw new Error('Location not found');
    leafletMap.setView([firstResult.lat, firstResult.lon], 15);
    return firstResult.display_name;
  } catch (error) {
    console.error(error);
    Bert.alert('Location not found', 'warning');
  }
};

export default searchLocation;
